import { useAppSelector } from "hooks/redux";
import React, { useLayoutEffect, useRef } from "react";
import "./websiteBuilderPreview.scss";
import "../designSpace/styles/website.scss";
import { websiteBuilderZLayers } from "../websiteBuilderZLayers";

export function WebsiteBuilderPreview() {
  const preview = useAppSelector(store => store.websiteBuilderStore.preview);
  const previewRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (previewRef.current) {
      previewRef.current.innerHTML = preview?.outerHTML ?? "";
    }
  }, [preview]);

  return (
    <div
      className="website-builder-preview-container"
      style={{
        zIndex: websiteBuilderZLayers.previewContainer,
      }}
    >
      <div ref={previewRef} className="website-builder-preview" />
    </div>
  );
}
